module.exports = __webpack_public_path__ + "static/media/happy_christmas_map.3865fb8d.svg";